// Trust video shown across the apply funnel, opportunity surfaces, and the
// recruitment auth screen so participants always see the "what is Terac"
// explainer one step away from the apply CTA. Self-hosted so the surfaces stay
// on-brand and free of third-party embed tracking.
export const TRUST_VIDEO_SRC = "/marketing/videos/what-is-terac.mp4";
export const TRUST_VIDEO_POSTER = "/marketing/videos/what-is-terac.jpg";
export const TRUST_VIDEO_TITLE = "What is Terac";
export const TRUST_VIDEO_HEADING = "About Terac";
export const TRUST_VIDEO_DESCRIPTION =
  "The expert network for AI training and research. We connect professionals like you with leading companies for paid projects that fit your expertise.";
